'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/message-base.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _grid = require('@marmalade/grid');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var imgStyles = function imgStyles(_ref) {
  var small = _ref.small,
    theme = _ref.theme;
  return _defineProperty({
    maxWidth: small ? '130px' : '180px',
    verticalAlign: 'middle',
    marginRight: theme.space_xs || '0.5rem',
    marginBottom: theme.space_xs || '0.5rem'
  }, (0, _themes.atLeast)(theme.breakpoint_lg || 1200), {
    marginBottom: 0
  });
};
var messageStyles = function messageStyles(_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    width: '100%',
    textAlign: 'center'
  }, (0, _themes.atLeast)(theme.breakpoint_lg || 1200), {
    width: 'auto',
    marginLeft: theme.space_md || '3rem',
    marginBottom: 0,
    textAlign: 'initial'
  });
};
MessageBase.propTypes = {
  message: _propTypes.node.isRequired,
  stars: _propTypes.number.isRequired,
  smallImage: _propTypes.bool,
  darkLogo: _propTypes.bool
};
MessageBase.defaultProps = {
  smallImage: false,
  darkLogo: false
};
var Img = (0, _glamorous2.default)('img')(imgStyles);
var Message = (0, _glamorous2.default)('div')(messageStyles);
function MessageBase(_ref5) {
  var darkLogo = _ref5.darkLogo,
    smallImage = _ref5.smallImage,
    stars = _ref5.stars,
    message = _ref5.message,
    rest = _objectWithoutProperties(_ref5, ['darkLogo', 'smallImage', 'stars', 'message']);
  return _react2.default.createElement(_glamorous2.default.Div, Object.assign({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    },
    __self: this
  }), _react2.default.createElement(_grid.Container, {
    css: {
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'center',
      justifyContent: 'center'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46
    },
    __self: this
  }, _react2.default.createElement('a', {
    href: 'https://www.trustpilot.com/review/wearemarmalade.co.uk',
    rel: 'nofollow noopener noreferrer',
    target: '_blank',
    style: {
      display: 'contents'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54
    },
    __self: this
  }, _react2.default.createElement(Img, {
    src: darkLogo ? 'https://cdn.trustpilot.net/brand-assets/1.1.0/logo-black.svg' : 'https://cdn.trustpilot.net/brand-assets/1.1.0/logo-white.svg',
    alt: 'TrustPilot',
    small: smallImage,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60
    },
    __self: this
  }), _react2.default.createElement(Img, {
    src: 'https://images-static.trustpilot.com/api/stars/' + stars + '/star.svg',
    alt: stars + ' Star Rating',
    small: smallImage,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69
    },
    __self: this
  })), _react2.default.createElement(Message, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75
    },
    __self: this
  }, message)));
}
exports.default = MessageBase;